var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoAlertPreviewIcon = function SvgNoAlertPreviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 34,
    fill: "none",
    viewBox: "0 0 40 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F677E",
    strokeLinecap: "round",
    d: "M.5 33h39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F677E",
    d: "M30.969 10.696a1 1 0 0 1 1-1h3.281a1 1 0 0 1 1 1v22.3h-5.281zM3.75 21.038a1 1 0 0 1 1-1h3.281a1 1 0 0 1 1 1V33H3.75zM13.094 16.987a1 1 0 0 1 1-1h3.281a1 1 0 0 1 1 1V33h-5.281zM22.031 21.443a1 1 0 0 1 1-1h3.282a1 1 0 0 1 1 1V33H22.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F677E",
    strokeLinecap: "round",
    d: "m2.349 11.147 3.96 3.686 9.243-4.476 8.714 4.213 9.506-11.585"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    stroke: "#5F677E",
    d: "M6.31 16.123c1.15 0 2.084-.93 2.084-2.08s-.935-2.08-2.085-2.08-2.084.93-2.084 2.08.935 2.08 2.084 2.08ZM15.288 12.437c1.15 0 2.084-.93 2.084-2.08s-.935-2.08-2.085-2.08-2.084.93-2.084 2.08.935 2.08 2.085 2.08ZM24.266 16.65c1.15 0 2.084-.93 2.084-2.08s-.935-2.08-2.084-2.08-2.085.93-2.085 2.08.935 2.08 2.085 2.08ZM33.244 5.065c1.15 0 2.084-.93 2.084-2.08s-.934-2.08-2.084-2.08-2.085.93-2.085 2.08.935 2.08 2.085 2.08Z"
  })));
};
export default SvgNoAlertPreviewIcon;